<template>
  <div id="app">
    <div class="header">
      <div class="container clearfix">
        <el-row class="PC">
          <el-col :span="24">
            <el-menu :default-active="activeIndex" :active-text-color="activeColor" :router="true" class="el-menu-demo"
              mode="horizontal" @select="handleSelect">
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/checkCenter">核验中心</el-menu-item>
              <el-menu-item index="/feature">功能场景</el-menu-item>
              <el-menu-item index="/documentCenter">文档中心</el-menu-item>
              <el-menu-item index="/aboutUs">关于我们</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg Mobile" justify="space-between">
          <el-col :span="8" class="m-box">
            <div class="menu-btn" @click="mobileNav"><span></span><span></span><span></span></div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div :class="['mobile-nav', [mobile_nav ? 'm-nav-show' : 'm-nav-hide']]">
      <el-row>
        <el-col :span="24" class="text-right" style="padding-right: 20px">
          <i class="el-icon-close" @click="mobileNav" style="color: #FFFFFF;font-size: 30px"></i>
        </el-col>
      </el-row>
      <el-menu :default-active="activeIndex" :active-text-color="activeColor" :router="true"
        class="el-menu-vertical-demo" background-color="transparent" text-color="#fff" style="margin: 20px 0">
        <el-menu-item index="/" class="m-menu-icon icon1" @click="mobileNav">
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/checkCenter" class="m-menu-icon icon2" @click="mobileNav">
          <span slot="title">核验中心</span>
        </el-menu-item>
        <el-menu-item index="/feature" class="m-menu-icon icon2" @click="mobileNav">
          <span slot="title">功能场景</span>
        </el-menu-item>
        <el-menu-item index="/documentCenter" class="m-menu-icon icon3" @click="mobileNav">
          <span slot="title">文档中心</span>
        </el-menu-item>
        <el-menu-item index="/aboutUs" class="m-menu-icon icon4" @click="mobileNav">
          <span slot="title">关于我们</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div :class="['main-content', { 'pdb0': activeIndex == '/contactUs' }]">
      <router-view :class="[activeIndex == '/contactUs' ? '' : 'content']"></router-view>
    </div>
    <Footer v-if="activeIndex != '/contactUs'"></Footer>
  </div>
</template>

<script>
import Footer from './components/footer/Footer'
import ElCol from "element-ui/packages/col/src/col";

export default {
  name: 'App',
  data() {
    return {
      activeIndex: '',
      activeColor: '#409EFF',
      mobile_nav: false
    };
  },
  components: {
    ElCol, Footer
  },
  methods: {
    handleSelect(val) {
      console.log('222')
    },
    mobileNav() {
      console.log('11')
      this.mobile_nav = !this.mobile_nav
    },
    getPath() {
      this.activeIndex = this.$route.path
    },
    goLogin(url, opt_label) {
      window.open(url)
      _hmt.push(['_trackEvent', 'login', 'click', opt_label])
    }
  },
  created() {
    this.activeIndex = this.$route.path
  },
  watch: {
    '$route': 'getPath'
  },
}
</script>


// WEBPACK FOOTER //
// src/App.vue